import { z } from 'zod';
import { FlowBlockValueUuidSchema } from '../../blockValue/uuidSchema.js';
import { FlowConsumerOfVoiceCallSchema } from '../consumer.js';
import { FlowVoiceCallReturnDataSchema } from '../voiceCall/config.js';
export var FlowHumanTaskBlockWorkContextContentType;
(function (FlowHumanTaskBlockWorkContextContentType) {
    FlowHumanTaskBlockWorkContextContentType["Ehr"] = "Ehr";
    FlowHumanTaskBlockWorkContextContentType["Url"] = "Url";
    FlowHumanTaskBlockWorkContextContentType["Pdf"] = "Pdf";
    FlowHumanTaskBlockWorkContextContentType["Markdown"] = "Markdown";
    FlowHumanTaskBlockWorkContextContentType["File"] = "File";
    FlowHumanTaskBlockWorkContextContentType["Portal"] = "Portal";
    FlowHumanTaskBlockWorkContextContentType["VoiceCall"] = "VoiceCall";
    FlowHumanTaskBlockWorkContextContentType["VoiceCallV2"] = "VoiceCallV2";
})(FlowHumanTaskBlockWorkContextContentType || (FlowHumanTaskBlockWorkContextContentType = {}));
export const BaseFlowHumanTaskWorkContextSchema = z.object({
    id: z.string(),
    name: z.string().optional(),
});
export const FlowHumanTaskWorkContextEhrConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.Ehr),
    ehrInstance: z.string(),
});
export const FlowHumanTaskWorkContextUrlConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.Url),
    url: z.string(),
});
export const FlowHumanTaskWorkContextPdfConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.Pdf),
    documentId: z.string(),
});
export const FlowHumanTaskWorkContextMarkdownConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.Markdown),
    markdownContent: z.string(),
});
export const FlowHumanTaskWorkContextFileConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.File),
    fileReference: z.string(),
});
export var FlowHumanTaskWorkContextPortal;
(function (FlowHumanTaskWorkContextPortal) {
    FlowHumanTaskWorkContextPortal["AerialGreaterTriCities"] = "AerialGreaterTriCities";
    FlowHumanTaskWorkContextPortal["AerialProspect"] = "AerialProspect";
    FlowHumanTaskWorkContextPortal["Availity"] = "Availity";
    FlowHumanTaskWorkContextPortal["BcbsmsMedicalNecessity"] = "BcbsmsMedicalNecessity";
    FlowHumanTaskWorkContextPortal["Bcbsri"] = "Bcbsri";
    FlowHumanTaskWorkContextPortal["Carelon"] = "Carelon";
    FlowHumanTaskWorkContextPortal["CareCore"] = "CareCore";
    FlowHumanTaskWorkContextPortal["Cohere"] = "Cohere";
    FlowHumanTaskWorkContextPortal["Evicore"] = "Evicore";
    FlowHumanTaskWorkContextPortal["EzNetImperial"] = "EzNetImperial";
    FlowHumanTaskWorkContextPortal["EzNetRadys"] = "EzNetRadys";
    FlowHumanTaskWorkContextPortal["EzNetSouthernCalifornia"] = "EzNetSouthernCalifornia";
    FlowHumanTaskWorkContextPortal["HealthHelp"] = "HealthHelp";
    FlowHumanTaskWorkContextPortal["Kaiser"] = "Kaiser";
    FlowHumanTaskWorkContextPortal["MedPoint"] = "MedPoint";
    FlowHumanTaskWorkContextPortal["MedSolutions"] = "MedSolutions";
    FlowHumanTaskWorkContextPortal["MHK"] = "MHK";
    FlowHumanTaskWorkContextPortal["NoPortal"] = "NoPortal";
    FlowHumanTaskWorkContextPortal["Regal"] = "Regal";
    FlowHumanTaskWorkContextPortal["OptumPro"] = "OptumPro";
    FlowHumanTaskWorkContextPortal["Procare"] = "Procare";
    FlowHumanTaskWorkContextPortal["RadMd"] = "RadMD";
    FlowHumanTaskWorkContextPortal["SanDiegoPace"] = "SanDiegoPace";
    FlowHumanTaskWorkContextPortal["Scripps"] = "Scripps";
    FlowHumanTaskWorkContextPortal["Sharp"] = "Sharp";
    FlowHumanTaskWorkContextPortal["UnitedHealthcare"] = "Uhc";
})(FlowHumanTaskWorkContextPortal || (FlowHumanTaskWorkContextPortal = {}));
export const FlowHumanTaskWorkContextPortalConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.Portal),
    portal: z.enum(FlowHumanTaskWorkContextPortal),
});
export const FlowHumanTaskWorkContextVoiceCallConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.VoiceCall),
    voiceCall: FlowConsumerOfVoiceCallSchema({ isRequired: true }),
    callSummary: z.string(),
    voiceCallData: FlowVoiceCallReturnDataSchema.optional(),
});
export const FlowHumanTaskWorkContextVoiceCallV2ConfigSchema = BaseFlowHumanTaskWorkContextSchema.extend({
    contentType: z.literal(FlowHumanTaskBlockWorkContextContentType.VoiceCallV2),
    voiceCallId: FlowBlockValueUuidSchema({ isRequired: true }),
});
export const FlowHumanTaskWorkContextSchema = z.discriminatedUnion('contentType', [
    FlowHumanTaskWorkContextEhrConfigSchema,
    FlowHumanTaskWorkContextUrlConfigSchema,
    FlowHumanTaskWorkContextPdfConfigSchema,
    FlowHumanTaskWorkContextMarkdownConfigSchema,
    FlowHumanTaskWorkContextFileConfigSchema,
    FlowHumanTaskWorkContextPortalConfigSchema,
    FlowHumanTaskWorkContextVoiceCallConfigSchema,
    FlowHumanTaskWorkContextVoiceCallV2ConfigSchema,
]);
//# sourceMappingURL=workContextConfig.js.map